import { Divider, Group, Text } from "@mantine/core";
import {
  MULTIPLACER_MODULES_BY_KEY,
  type IMultiplacerModuleKey,
} from "@multiconsult-group/multiplacer-core";
import { MODULE_ICON_BY_KEY } from "../designModuleIcons";

export function ModuleToolbarLabel({ module }: { module: IMultiplacerModuleKey }) {
  const Icon = MODULE_ICON_BY_KEY[module];
  return (
    <Group gap="sm" wrap="nowrap" style={{ flexShrink: 0 }}>
      <Icon size={16} aria-hidden="true" />
      <Text fw={600} size="sm" style={{ whiteSpace: "nowrap" }}>
        {MULTIPLACER_MODULES_BY_KEY[module].title}
      </Text>
      <Divider orientation="vertical" h={24} />
    </Group>
  );
}
